import { Component, OnInit } from '@angular/core';
import { AbstractDisplayComponent } from '../abstract-display.component';
import * as moment from 'moment';

@Component({
    selector: 'dmp-date-display',
    templateUrl: './date-display.component.html',
    styleUrls: ['./date-display.component.scss'],
    standalone: false
})
export class DateDisplayComponent extends AbstractDisplayComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    moment.locale('fr');
    this.displayHover = this.value;
    const date = moment(this.value);
    let format = null;
    switch (this.field.type) {
      case 'Date':
        format = 'L';
        break;
      case 'Time':
        format = 'LTS';
        break;
      case 'DateTime':
        format = 'LLLL';
        break;

      default:
        break;
      }
    if (format && date.isValid()) {
      this.display = date.format(format);
    } else {
      this.display = this.value;
    }
  }

  getTooltip(){

  }


}
